<div class='not-found-background center-me'>
  <mat-card class="not-found-card">
    <mat-card-header>
      <!-- https://material.io/tools/icons/?style=outline -->
      <div mat-card-avatar><mat-icon>error_outline</mat-icon></div>
      <mat-card-title>{{'common.labels.notFoundTitle' | translate}}</mat-card-title>
      <mat-card-subtitle>{{'common.messages.errors.404' | translate}}</mat-card-subtitle>
    </mat-card-header>
    <img mat-card-image class=" w-full m-0" src="assets/images/heronew.png" alt="Tiwp Logo">
    <mat-card-actions>
      <button mat-stroked-button class="gohome-button primary-button" (click)="goHome()">
        <a routerLink="">{{'common.labels.goHomeButton' | translate}}</a>
        <mat-icon>home</mat-icon>
      </button>
      </mat-card-actions>
  </mat-card>
</div>
